import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Services } from '../components/Services';
import { AboutMason } from '../components/AboutMason';
import { WhyUs } from '../components/WhyUs';
import { Testimonials } from '../components/Testimonials';
import { ServiceArea } from '../components/ServiceArea';
import { Faq } from '../components/Faq';
import { QuoteForm } from '../components/QuoteForm';
import { Footer } from '../components/Footer';
import { StickyCallBar } from '../components/StickyCallBar';
type HomeProps = {
  logoVariant: 'badge' | 'wordmark';
  showFaq: boolean;
};
export function Home({
  logoVariant,
  showFaq
}: HomeProps) {
  return <div className="min-h-screen w-full bg-white font-heading text-brand-navy" data-id="element-239" data-mp="2dj1o6y6ltpal">
      <Header logoVariant={logoVariant} data-id="element-240" data-mp="3kuiijhaa4o7w" />
      <main data-id="element-241" data-mp="3owvn42daig33">
        <Hero data-id="element-242" data-mp="3owlxifw5qaxx" />
        <Marquee data-id="element-243" data-mp="3ow43lpwyw8t6" />
        <Services data-id="element-244" data-mp="3ovkiy1fxn6bg" />
        <AboutMason data-id="element-245" data-mp="3ov2fokuurru1" />
        <WhyUs data-id="element-246" data-mp="3oyqadnc1akac" />
        <Testimonials data-id="element-247" data-mp="30wjaok4gik28" />
        <ServiceArea data-id="element-248" data-mp="30x1eq2xd22kp" />
        {showFaq && <Faq data-id="element-249" data-mp="30w04g0o65k41" />}
        <QuoteForm data-id="element-250" data-mp="30ufbgfhi698a" />
      </main>
      <Footer logoVariant={logoVariant} data-id="element-251" data-mp="2vx6swdsg036i" />
      <StickyCallBar data-id="element-252" data-mp="2vy85wnt0qzqv" />
    </div>;
}